import { Credit } from "@/core/entities/credit";
import { GetCreditParams, ICreditRepository } from "@/core/repositories/credit";
import { createLogger, ILogger } from "@/infrastructure/services/logger";

export class GetCreditUseCase {
    private readonly logger: ILogger = createLogger("GetCreditUseCase");

    constructor(private readonly creditRepository: ICreditRepository) { }

    async execute(params: GetCreditParams): Promise<Credit> {
        try {
            const credit = await this.creditRepository.getCredit(params);
            return new Credit(credit.credit);
        } catch (error: any) {
            this.logger.error(error?.message ?? "Error getting credit", error);
            throw error;
        }
    }
}